import { toast } from "react-toastify";
import { endpoints, oids } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { IPractitionerData } from "../../../utils/interfaces";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";
import { auxiliarData } from "../AuxiliarData";
import { OAuthApplication } from "@/services/auth";

/**
 * Atualiza os dados de um Practitioner
 * @param objData Dados do Practitioner
 * @param authType Tipo de autenticação ('application' para usar token de aplicação)
 * @param skipTargetSystem Se true, não envia o header X-Target-System
 * @returns Resposta da API
 */
export async function PutPractitioner(
  objData: IPractitionerData,
  authType?: string
) {
  const cpf = objData.identifier;
  const url = `${endpoints.ADMFHIR}/Practitioner/${oids.cpf}-${cpf}`;

  const data = auxiliarData.Practitioner({
    ...objData,
  });
  const headers = {
    Accept: "*/*",
    Authorization:
      authType === "application"
        ? await OAuthApplication()
        : await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
  };
  const response = await useAxios
    .put(url, data, {
      headers,
      timeout: 20000,
    })
    .then((response) => {
      if (
        response.status !== HTTPResponseStatus.Created &&
        response.status !== HTTPResponseStatus.Success
      ) {
        throw new Error(`PutPractitioner: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("PutPractitioner ", error);
      // toast.error(`PutPractitioner Error: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
